import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const getTemplateControllerAsync = (all = false) => {
  const url = getUrl("templateControllers");
  return trackPromise(Call.get(`${url}?all=${all}`));
};

export const requestTestSensorsAsync = (mac) => {
  const url = getUrl("testSensor")(mac);
  return trackPromise(Call.get(url));
};

export const getNonTestTemplateAsync = (id) => {
  const url = getUrl("nonTestTemplate");
  const patchurl = `${url}${id}/`;
  return trackPromise(Call.get(patchurl));
};

export const createNonTestTemplateAsync = (payload) => {
  const url = getUrl("nonTestTemplate");
  const {id = ""} = payload;
  if (id) {
    const patchurl = `${url}${payload.id}/`;
    return trackPromise(Call.patch(patchurl, payload));
  } else {
    return trackPromise(Call.post(url, payload));
  }
};

export const getTemplateAsync = () => {
  const url = getUrl("templates");
  return trackPromise(Call.get(url));
};

export const getEachTemplateAsync = (id) => {
  const url = getUrl("templates");
  const patchurl = `${url}${id}/`;
  return trackPromise(Call.get(patchurl));
};

export const createTemplatesAsync = (payload) => {
  const url = getUrl("templates");
  const {id = ""} = payload;
  if (id) {
    const patchurl = `${url}${payload.id}/`;
    return trackPromise(Call.patch(patchurl, payload));
  } else {
    return trackPromise(Call.post(url, payload));
  }
};

export const deleteTemplatesAsync = (id) => {
  const url = getUrl("templates");
  const patchurl = `${url}${id}/`;
  return trackPromise(Call.delete(patchurl));
};

export const getReportSitesAsync = () => {
  const url = getUrl("reports");
  return trackPromise(Call.get(`${url}sites/`));
};

export const getReportLocationsAsync = (site_id) => {
  const url = getUrl("reports");
  return trackPromise(Call.post(`${url}locations/`, {site_id}));
};

export const getReportControllersAsync = (location_id) => {
  const url = getUrl("reports");
  return trackPromise(Call.post(`${url}controllers/`, {location_id}));
};

export const getRecordAsync = (inventory_id) => {
  const url = getUrl("reports");
  return trackPromise(Call.post(`${url}templates/`, {inventory_id}));
};

export const createReportAsync = (payload) => {
  const {id} = payload;
  const url = getUrl("reports");
  if (id) {
    return trackPromise(Call.patch(`${url}${id}/`, payload));
  } else {
    return trackPromise(Call.post(url, payload));
  }
};

export const getReportsAsync = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("reports");
  return trackPromise(Call.get(url));
};

export const getEachReportAsync = (id) => {
  const url = getUrl("reports");
  return trackPromise(Call.get(`${url}${id}/`));
};

export const changeReportStatusAsync = (id, status) => {
  const url = getUrl("reports");
  return trackPromise(Call.post(`${url}${id}/change_status/`, {status}));
};

export const requestReportAnalysisAsync = (id) => {
  const url = getUrl("reports");
  return trackPromise(Call.get(`${url}${id}/analysis/`));
};

export const requestReportPDFAsync = (id) => {
  const url = getUrl("reports");
  return trackPromise(Call.get(`${url}${id}/pdf/`));
};

export const deleteReportAsync = (id) => {
  const url = getUrl("reports");
  return trackPromise(Call.delete(`${url}${id}/`));
};
